import {Switch as BaseSwitch} from '@yandex-delivery/blocks'
import {type ReactElement, useCallback, useState} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {useFormUserEventHandler} from '../../lib/metrika'
import type {OrderFormState} from '../../types'
import {type WidgetPropsByType, WidgetType} from '../types'

/**
 * Компонент свитчера.
 * поле value указывает, должны ли значения быть инвертированными.
 * Если в нем приходит false, то при включенном тоггле в ручки формы и заказа должно уходить false, а при выключенном true
 */
export const Switch = ({
  enabled,
  metrica_label,
  name,
  value: configValue,
}: WidgetPropsByType<WidgetType.SWITCH>): ReactElement => {
  const {control} = useFormContext<OrderFormState>()
  const {
    field: {onChange, value, ...field},
  } = useController({name, control})
  const [innerValue, setInnerValue] = useState(configValue ? value : !value)
  const handleReachGoal = useFormUserEventHandler()

  const handleChange = useCallback(() => {
    if (metrica_label) {
      handleReachGoal(metrica_label)
    }
    setInnerValue(() => {
      onChange(configValue ? !innerValue : innerValue)
      return !innerValue
    })
  }, [configValue, handleReachGoal, innerValue, metrica_label, onChange])

  return <BaseSwitch {...field} disabled={!enabled} on={innerValue} onChange={handleChange} />
}
